import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';
import { IBanner } from '../../types/banners';

export enum EBannersActionTypes {
  SetBanners = 'BANNERS/SET',
}

export type TSetBanners = ITypedReduxAction<EBannersActionTypes.SetBanners, IBanner[]>;

export const setBanners: (banners: IBanner[]) => TSetBanners = actionGenerator<
  EBannersActionTypes.SetBanners,
  IBanner[]
>(EBannersActionTypes.SetBanners);
